import { UserBoardComponentMode } from "src/app/services/models/user-board.model";

export enum StoredHeroDataTypes {
  metric = 'metric',
  text = 'text'
}

export class HeroPiece {
  type: StoredHeroDataTypes;
  value: any;

  constructor(type: StoredHeroDataTypes, value: any) {
    this.type = type;
    this.value = value;  }
}

export class StoredMetric {
  metricId: number;
  metricName: string;

  constructor(metricId: number, metricName: string) {
    this.metricId = metricId;
    this.metricName = metricName;
  }
}

export class GroupByOption {
  datasetId: string;
  datasetPrimaryKey: string;  // Primary key field ID of the reference dataset (used in groupBy)
  fieldToDisplay: string;      // Display name of the selected field
  fieldIdToDisplay: string;    // Field ID to use for displaying values from response

  constructor(datasetId: string, datasetPrimaryKey: string, fieldToDisplay: string, fieldIdToDisplay: string) {
    this.datasetId = datasetId;
    this.datasetPrimaryKey = datasetPrimaryKey;
    this.fieldToDisplay = fieldToDisplay;
    this.fieldIdToDisplay = fieldIdToDisplay;
  }
}

export interface ITileComponent {
  data: any;
  mode: UserBoardComponentMode;
}
